import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  clickable: css`
    cursor: pointer;
  `,
  iconClosed: css`
    transform: rotate(-90deg);
  `,
  iconOpened: css`
    transform: rotate(-180deg);
  `,
}
